"use client";

import { ActionState } from "@/actions/add-testimonial";
import subscribe from "@/actions/subscribe";
import { Button } from "@/components/ui/button";
import CustomInput from "@/components/ui/form/CustomInput";
import RenderFieldError from "@/components/ui/form/RenderFieldError";
import { useTranslations } from "next-intl";
import { useActionState, useEffect, useState } from "react";
import { initialActionState } from "../testimonials/form/TestimonialForm";
import { clearError } from "@/utils/utils";
import { showSuccessToast } from "@/utils/showToast";
import { ConfettiStars } from "@/animations/ConfettiStars";

const SubscriptionForm = () => {
  const t = useTranslations();
  const [state, subscribeAction, isPending] = useActionState<
    ActionState,
    FormData
  >(subscribe, initialActionState);

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    setErrors(state.errors);
    if (state.success) {
      setErrors({});
      showSuccessToast(state.message || "Subscribed successfully");
      setShowConfetti(true);

      // hide confetti after 3s if you want
      setTimeout(() => setShowConfetti(false), 2000);
    }
  }, [state.success, state.errors, state.message]);

  return (
    <div className="relative w-full">
      {showConfetti && <ConfettiStars />}

      <form
        action={subscribeAction}
        className="flex items-center lg:items-start gap-3 mt-6 w-full justify-center flex-col lg:flex-row"
      >
        <div className="w-full xl:w-[25%]">
          <CustomInput
            type="text"
            name="name"
            placeholder="Enter your name"
            className="w-full h-10 lg:h-[48px]"
            onChange={() => clearError(setErrors, "name")}
          />
          {errors?.name && (
            <RenderFieldError errors={errors} fieldName="name" />
          )}
        </div>

        <div className="w-full xl:w-[75%]">
          <CustomInput
            type="email"
            name="email"
            placeholder="Enter your email"
            className="w-full h-10 lg:h-[48px]"
            onChange={() => clearError(setErrors, "email")}
          />
          {errors?.email && (
            <RenderFieldError errors={errors} fieldName="email" />
          )}
        </div>

        <Button
          disabled={isPending}
          type="submit"
          aria-label="Subscribe"
          className="h-10 lg:h-[48px]"
        >
          {t("Subscribe")}
        </Button>
      </form>
    </div>
  );
};

export default SubscriptionForm;
